import React from 'react';

const AuthFooter = () => {
  return (
    <div className='col'>
      <div className='auth-footer d-flex justify-content-center align-items-end bottom-banner h-100 pb-3 text-center'>
        <p>
          <span className='text-green'>Terms & Conditions</span> and{' '}
          <span className='text-green'>Privacy Policy</span>
        </p>
      </div>
    </div>
  );
};

export default AuthFooter;
